export default __webpack_public_path__ + "static/media/test-1920x1080.2ecc94d9.png";